;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('productValidation', productValidationDirective)

  productValidationDirective.$inject = ['$q', 'ProductManager']

  function productValidationDirective ($q, ProductManager) {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        ctrl.asyncValidators = ctrl.asyncValidators || {}
        var type = attrs.productValidation
        ctrl.$asyncValidators[type] = function (modelValue, viewValue) {
          if (ctrl.$isEmpty(modelValue)) {
            return $q.when()
          }
          var def = $q.defer()
          ProductManager.get(
            ProductManager.query({conditions: {'flags': 'sufa'}})
              .select(viewValue, type))
            .then(function (found) {
              if (parseInt(found.meta.total) > 0) {
                _.map(found.data, '_id').includes(attrs.product) ? def.resolve() : def.reject()
              } else {
                def.resolve()
              }
            })
          return def.promise
        }
      }
    }
  }
})(window.angular, window._)
